import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import './ContactMe.css';

const ContactMe = () => {
    const [success, setSuccess] = useState(false);

    const sendEmail = (e) => {
        e.preventDefault();
        emailjs.sendForm('service_5ff3p9x', 'template_wcvaxfl', e.target, 'user_0I50hgrwN6SybnFjW1APH')
            .then((result) => {
                console.log(result.text);
                setSuccess(true);
            }, (error) => {
                console.log(error.text);
            });
        e.target.reset();
    };

    return (
        <div id="contact">
            <div className="contact section-container">
                <div>
                    <h1 className="section-title contact-me-title">Contact <span>me</span></h1>
                </div>
                <div className="vertical"></div>
                <div className="contact-items row d-flex justify-content-between">
                    <div className="col-12 col-md-5">
                        <div className="row g-5 mb-5 mb-md-0">
                            <div className="contact-item col-12">
                                <div className="contact-info">
                                    <h1>Phone</h1>
                                    <h2>+88 01636 456927</h2>
                                    <h2>+88 01812 128720</h2>
                                </div>
                                <i class="fa-solid fa-phone"></i>
                            </div>
                            <div className="contact-item col-12">
                                <div className="contact-info">
                                    <h1>Email</h1>
                                    <h2>royavijit782@gmail.com</h2>
                                </div>
                                <i className="fas fa-envelope"></i>
                            </div>
                            <div className="contact-item col-12">
                                <div className="contact-info">
                                    <h1>Address</h1>
                                    <h2>Dhanmondi, Dhaka, Bangladesh</h2>
                                    <h2>Fenchuganj, Sylhet, Bangladesh</h2>
                                </div>
                                <i className="fas fa-map-marker-alt"></i>
                            </div>
                        </div>
                    </div>
                    <form onSubmit={sendEmail} className="col-12 col-md-5 form">
                        <div className="mb-5">
                            <label htmlFor="name" className="fs-2">Full Name</label>
                            <input type="text" className="form-control py-4 rounded-0 fs-4" id="name" placeholder="Name" name="name" required />
                        </div>
                        <div className="mb-5">
                            <label htmlFor="email" className="fs-2">Email address</label>
                            <input type="email" className="form-control py-4 rounded-0 fs-4" id="email" placeholder="abc@pqr.xyz" name="email" required />
                        </div>
                        <div className="mb-5">
                            <label htmlFor="messages" className="fs-2">Messages</label>
                            <textarea className="form-control py-4 rounded-0 fs-4"
                                placeholder="Your message" id="messages" rows="10" name="messages" required>
                            </textarea>
                        </div>
                        <button type="submit" className="text-dark cta py-3">Send</button>
                        {success && <p>Email successfully sent</p>}
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ContactMe;